// extracted by mini-css-extract-plugin
export default {"card":"CardMartiller_card__h2Sci","header":"CardMartiller_header__FDLBU","photo":"CardMartiller_photo__10TID","name":"CardMartiller_name__2mBX8","link":"CardMartiller_link__jlGYJ"};